module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "HomePage"
  }, [_c('header-component'), _vm._v(" "), _c('div', {
    staticStyle: {
      "border-bottom": "solid 1px whitesmoke",
      "height": "1px"
    }
  }), _vm._v(" "), _c('home-banner'), _vm._v(" "), _c('home-icons'), _vm._v(" "), _c('home-promo'), _vm._v(" "), _c('home-block'), _vm._v(" "), _c('home-story'), _vm._v(" "), (_vm.elementConfig.inviteColleagueShow || _vm.MasterAccountType == 'master') ? _c('home-invite') : _vm._e(), _vm._v(" "), _c('help-info'), _vm._v(" "), _c('footer-component'), _vm._v(" "), (_vm.isCovidReliefModalFormShow) ? _c('div', [_c('covid-relief-modal-form', {
    on: {
      "CtlModalForm": function($event) {
        return _vm.CtlModalForm()
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isCovidReliefFeedbackResultModalShow) ? _c('div', [_c('covid-relief-feedback-result-modal', {
    attrs: {
      "crps": _vm.crps
    },
    on: {
      "CtlCovidReliefFeedbackResultModal": function($event) {
        return _vm.CtlCovidReliefFeedbackResultModal()
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._v(".\n")], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-15d8baf1", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15d8baf1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/Home.vue
// module id = 462
// module chunks = 3